<fieldset class="fieldset-container" [disabled]="disableForm" [ngClass]="{'form--disabled': disableForm}">
  <ng-content></ng-content>
</fieldset>
